import { render, staticRenderFns } from "./CCMFunctionalStatusEdit.vue?vue&type=template&id=36bd1796"
import script from "./CCMFunctionalStatusEdit.vue?vue&type=script&lang=js"
export * from "./CCMFunctionalStatusEdit.vue?vue&type=script&lang=js"
import style0 from "./CCMFunctionalStatusEdit.vue?vue&type=style&index=0&id=36bd1796&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports